import { useContext } from 'react';

import { ToastContext } from '@/components/providers';

export const useToast = () => useContext(ToastContext);
